<template lang="pug">
.FKeyFeatureItem
  FLogo(
    variant="image-only"
    :width="width"
  )
  p.FKeyFeatureItem__text(v-html="text")
</template>

<style lang="stylus">
.FKeyFeatureItem
  display flex
  align-items center

  &__text
    use-font('heading-5')

    +media-down('sm')
      use-font('heading-6')

.FKeyFeatureItem .FLogo
  margin-right rem(20)
</style>

<script setup lang="ts">
/**
 * Type representing a feature
 */
export type KeyFeature = {
  text: string;
};

export interface FKeyFeatureItemProps {
  /**
   * Text of the feature
   */
  text: string;
  /**
   * Size of the logo
   */
  logoSize?: number;
}

const props = withDefaults(defineProps<FKeyFeatureItemProps>(), {
  logoSize: 80,
});

const { smAndDown } = useFBreakpoints();

const width = computed(() => smAndDown(60, props.logoSize));
</script>
